export default __webpack_public_path__ + "static/media/strange-trails.9581393b.jpg";